export const PD_STEPS = ["postcode", "route", "pdscreen", "site", "configurator", "quote", "book"];
export const PLANNING_STEPS = ["postcode", "route", "planning", "book"];
export const PHASES = ["Eligibility", "Property & Size", "Site & Logistics", "Configure & Price", "Book"];
export const PHASE_OF = { postcode: 0, route: 0, pdscreen: 1, site: 2, configurator: 3, quote: 3, planning: 3, book: 4 };

export const STARTER_CONFIG = {
  width: 4.0, depth: 3.0, height: 2.4,
  walls: "brick", brick_colour: "red_multi", roof: "flat_felt",
  doors: "french", bifold_opening_m: 2.5,
  window_width_mm: 650, window_colour: "anthracite",
  skylight: false, skylight_count: 0,
  window_position: 0, door_position: 0, skylight_position: 0, skylight_position_x: 0,
  knock_through: "keep",
  hob: "electric", boiler: "keep",
  floor: "laminate",
  kitchen_install: null, kitchen_design: false, kitchen_location: "new",
  lighting: { type: "centre", spot_count: 0 },
  radiators: 0, underfloor_heating: false,
  extra_windows: 0, lantern_count: 0,
  no_window: false,
  bathroom_choice: "none", bathroom_location: "new", toilet_type: "close_coupled",
  making_good: {}, additions: { extra_sockets: 0, extra_wall_lights: 0, undercabinet_lights: false },
};
